<div class="checkbox" ng-repeat="produto in $ctrl.insumos track by $index ">
  <label>
    <input type="checkbox" ng-model="produto.selecionado"> {{produto.insumo_was.descricao}}
  </label>
</div>
